"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Flash: ['flash', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,8H13.4L17.924.763A.5.5,0,0,0,17.5,0h-8a.5.5,0,0,0-.485.379l-3,12A.5.5,0,0,0,6.5,13H9.845L7.018,23.367a.5.5,0,0,0,.275.587.509.509,0,0,0,.623-.178l10-15A.5.5,0,0,0,17.5,8Z']],
  FlashOff: ['flash-off', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.431,23.153a1,1,0,0,0,0-1.414l-7.166-7.166,3.418-4.784A.5.5,0,0,0,19.276,9H11.9L13.764.606a.5.5,0,0,0-.895-.4L8.3,6.606,1.983.291A1,1,0,0,0,.569,1.705L22.083,23.2a.975.975,0,0,0,1.348-.044Z', 'M6.454,9.689a.25.25,0,0,0-.38.032l-3.2,4.487a.5.5,0,0,0,.407.79h7.376L8.788,23.39a.5.5,0,0,0,.284.565.505.505,0,0,0,.2.043.5.5,0,0,0,.407-.209l4.406-6.17a.249.249,0,0,0-.027-.322Z']],
  Flash1: ['flash-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.444,9.27A.5.5,0,0,0,20,9H12.624L14.488.606a.5.5,0,0,0-.895-.4l-10,14A.5.5,0,0,0,4,15h7.376L9.512,23.39a.5.5,0,0,0,.895.4l10-14A.5.5,0,0,0,20.444,9.27Z']]
};
exports["default"] = _default;